// react
import React from "react"
// material-ui
import { Card, CardTitle, CardActions, CardText } from "material-ui/Card"
import FlatButton from "material-ui/FlatButton"
// app
import TextField from "components/common/TextField"
import SaveCancel from "components/common/buttons/SaveCancel"


const initialState = {
    edit: false,
    newpwd: "",
    oldpwd: "",
    retyped: "",
    password_error: false
}

class UserDetails extends React.Component {
    constructor(props) {
        super()
        this.state = initialState

        this.oldPasswordChange = (oldpwd) => this.setState({ oldpwd })
        this.newPasswordChange = (newpwd) => {
            this.setState({ newpwd })
            
            if (this.state.retyped !== newpwd) {
                this.setState({ password_error: true })
            } else {
                this.setState({ password_error: false })
            }
        }
        this.retypePasswordChange = (retyped) => {
            this.setState({ retyped })

            if (this.state.newpwd !== retyped) {
                this.setState({ password_error: true })
            } else {
                this.setState({ password_error: false })
            }
        }

        this.cancel = () => this.setState(initialState)
        this.edit = () => this.setState({ edit: true })
        this.save = () => {
            const { newpwd, oldpwd } = this.state
            this.props.onSave(oldpwd, newpwd)
            this.setState(initialState)
        }
    }

    renderView() {
        return (
            <CardActions>
                <FlatButton
                    label="Change Password"
                    primary={ true }
                    onClick={ this.edit }
                />
            </CardActions>
        )
    }

    renderEdit() {
        return (
            <div>
                <CardText>
                    <TextField
                        autoFocus={ true }
                        label="Current Password"
                        type="password"
                        onChange={ this.oldPasswordChange }
                    />
                    <TextField
                        label="New Password"
                        type="password"
                        onChange={ this.newPasswordChange }
                    />
                    <TextField
                        label="Re-Type New Password"
                        type="password"
                        onChange={ this.retypePasswordChange }
                    />
                </CardText>
                <CardActions>
                    <SaveCancel
                        onSave={ this.save }
                        onCancel={ this.cancel }
                        disabled={ this.state.password_error === true }
                    />
                </CardActions>
            </div>
        )
    }

    render() {
        return (
            <Card className="card">
                <CardTitle
                    title={ this.props.email }
                    subtitle={ this.props.isAdmin === true ?
                        "Administrator" :
                        "joined on " + this.props.since }
                />
                { this.state.edit === true ?
                    this.renderEdit() :
                    this.renderView()
                }
            </Card>
        )
    }
}

UserDetails.propTypes = {
    email: React.PropTypes.string.isRequired,
    isAdmin: React.PropTypes.bool.isRequired,
    since: React.PropTypes.string.isRequired,
    userName: React.PropTypes.string.isRequired,
    onSave: React.PropTypes.func.isRequired
}

export default UserDetails


/** WEBPACK FOOTER **
 ** ./src/components/user/Details/user-details.js
 **/